import CategoryPathHeader from './categoryPathHeader'
import type { FC } from 'react'
import { SlugPathItem } from 'types/slugPath'

type ProductListingPathHeaderProps = {
  title: string
  paths: SlugPathItem[]
}

const ProductListingPathHeader: FC<ProductListingPathHeaderProps> = ({
  title,
  paths
}) => {
  return (
    <CategoryPathHeader
      mb={title ? '4px' : '58px'}
      display={'flex'}
      paths={paths}
    />
  )
}

export default ProductListingPathHeader
